import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { BookCallButton } from './BookCallButton';
const navLinks = [{
  label: 'About',
  to: '/about'
}, {
  label: 'Program',
  to: '/#programs'
}, {
  label: 'Impact',
  to: '/#impact'
}, {
  label: 'Resources',
  to: '/#resources'
}];
export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);
  // Lock body scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);
  return <>
      <nav className="w-full pt-6 pb-2 px-6 md:px-12 flex items-center justify-between max-w-7xl mx-auto relative z-30" data-id="element-95">
        <Link to="/" className="flex items-center" aria-label="Year One Mentor home" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/c9sWKrnv1vxYm1ZPgVh9dm/ChatGPT_Image_May_13,_2026,_09_40_06_PM.png" alt="Year One Mentor" className="h-[66px] md:h-[80px] w-auto" data-id="element-97" />
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-ink/80" data-id="element-98">
          {navLinks.map(link => <Link key={link.to} to={link.to} className="hover:text-teal transition-colors" data-id="element-99">
              {link.label}
            </Link>)}
        </div>

        <div className="hidden md:block" data-id="element-100">
          <BookCallButton className="btn-primary py-2.5 text-sm" data-id="element-101" />
        </div>

        {/* Mobile hamburger */}
        <button type="button" onClick={() => setMobileOpen(true)} className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md text-ink hover:bg-ink/5 transition-colors" aria-label="Open menu" aria-expanded={mobileOpen} data-id="element-102">
          <MenuIcon className="w-6 h-6" data-id="element-103" />
        </button>
      </nav>

      {/* Mobile menu overlay */}
      <AnimatePresence data-id="element-104">
        {mobileOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} onClick={() => setMobileOpen(false)} className="fixed inset-0 bg-ink/30 backdrop-blur-sm z-40 md:hidden" data-id="element-105" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          duration: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="fixed top-0 right-0 bottom-0 w-[85%] max-w-sm bg-ivory z-50 md:hidden flex flex-col shadow-2xl" data-id="element-106">
              <div className="flex items-center justify-between p-6 border-b border-ink/10" data-id="element-107">
                <img src="https://cdn.magicpatterns.com/uploads/c9sWKrnv1vxYm1ZPgVh9dm/ChatGPT_Image_May_13,_2026,_09_40_06_PM.png" alt="Year One Mentor" className="h-12 w-auto" data-id="element-108" />
                <button type="button" onClick={() => setMobileOpen(false)} aria-label="Close menu" className="w-10 h-10 inline-flex items-center justify-center rounded-md text-ink hover:bg-ink/5" data-id="element-109">
                  <XIcon className="w-6 h-6" data-id="element-110" />
                </button>
              </div>

              <nav className="flex-1 px-6 py-8 flex flex-col gap-1" data-id="element-111">
                {navLinks.map(link => <Link key={link.to} to={link.to} className="py-3 text-2xl font-serif text-ink hover:text-teal transition-colors border-b border-ink/5" data-id="element-112">
                    {link.label}
                  </Link>)}
              </nav>

              <div className="p-6 border-t border-ink/10" data-id="element-113">
                <BookCallButton className="btn-primary w-full py-3" data-id="element-114" />
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}